import script from "./MultiSelectDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MultiSelectDropdown.vue?vue&type=style&index=0&id=bf610e26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf610e26"]])

export default __exports__